import React from 'react';
import Modal from 'react-modal';
import Styled from './styles';
import { Typography } from '../../../typography';
import { useGlobalModalContext } from '../..';
import MUIButton from '../../../mui-button';
import colors from "../../../../assets/colors";
import CloseIcon from "@material-ui/icons/Close";

export const DisconnectCrmModal = () => {
	const { hideModal, store } = useGlobalModalContext();
	const { modalProps } = store || {};
	const { item, confirmCallback } = modalProps || {};
	const { logo, name, _id } = item;

	const handleModalToggle = () => {
		hideModal();
	};

	return (
		<Modal
			isOpen={true}
			className={'Settings'}
			onRequestClose={handleModalToggle}
			shouldCloseOnEsc
			shouldCloseOnOverlayClick
		>
			<Styled.ModalContent>
				<Styled.Close onClick={handleModalToggle}>
					<CloseIcon style={{ color: colors.black }} />
				</Styled.Close>
				{logo ? (
					<img src={logo} style={{ height: 160, marginBottom: 40 }} alt="" />
				) : (
					<Typography text={name} />
				)}
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						width: '100%',
						marginTop: 50,
						gap: 20,
					}}
				>
					<MUIButton title="Back" callBack={handleModalToggle} />
					<MUIButton
						title="Disconnect"
						callBack={() => {
							handleModalToggle();
							confirmCallback(_id);
						}}
						variant="outlined"
						backgroundColor="none"
						color="black"
					/>
				</div>
			</Styled.ModalContent>
		</Modal>
	);
};
